<div *ngIf="summary" class="status-summary-container">
  <div class="text-center mb-4">
    <h5 class="mb-2">{{_apolusService.literals.TotalMeterPark}}</h5>
    <h2 class="mb-0 text-primary">{{ summary?.TotalDevices | number }}</h2>
  </div>

  <div class="status-items">
    <div class="d-flex align-items-center mb-4" style="gap: 1rem;">
      <div class="cnm-icon-wrapper" style="background-color: #1bce44;">
        <i class="fas fa-tachometer fa text-white"></i>
      </div>

      <div class="flex-grow-1 w-100">
        <div class="font-weight-bold mb-1">
          {{ getPercentage(summary.OnlineDevices, summary.TotalDevices) }}% ({{ summary.OnlineDevices | number }} / {{ summary.TotalDevices | number }})
        </div>
        <div class="text-muted mb-1">{{_apolusService.literals.OnlineMeters}}</div>
        <cnm-progress
          [max]="100"
          color="#28a745"
          [value]="getPercentage(summary.OnlineDevices, summary.TotalDevices)"
          [rawValue]="summary.OnlineDevices"
          [height]="6">
        </cnm-progress>
      </div>
    </div>

    <div class="d-flex align-items-center mb-4" style="gap: 1rem;">
      <div class="cnm-icon-wrapper" style="background-color: #f22035;">
        <i class="fas fa-exclamation-triangle fa text-white"></i>
      </div>

      <div class="flex-grow-1 w-100">
        <div class="font-weight-bold mb-1">
          {{ getPercentage(summary.WithAlarmDevices, summary.TotalDevices) }}% ({{ summary.WithAlarmDevices | number }} / {{ summary.TotalDevices | number }})
        </div>
        <div class="text-muted mb-1">{{appService.CoreCommonLiterals?.ActiveAlarms}}</div>

        <cnm-progress
          [max]="100"
          color="#dc3545"
          [value]="getPercentage(summary.WithAlarmDevices, summary.TotalDevices)"
          [rawValue]="summary.WithAlarmDevices"
          [height]="6">
        </cnm-progress>
      </div>
    </div>
  </div>
</div>
